import { createContext } from "react";
import { ApiError } from "go-core/api/types";
import { OrderData } from "../../../../../services/Api/Public/types";

export interface OrderContextData {
	orderId?: string;
	order?: OrderData;
	setOrder: (order?: OrderData) => void;
	setTipAmount: (tipAmount: number | undefined) => void;
	matchUrl: string;
	tipAmount?: number;
	paymentSuccess: boolean;
	setPaymentSuccess: (paymentSuccess: boolean) => void;
	errors: ApiError[];
	redirectUrl: string;
	setRedirectUrl: (redirectUrl: string) => void;
}

export const OrderContext = createContext<OrderContextData>({
	setOrder: (_?: OrderData) => {},
	setTipAmount: (_: number | undefined) => {},
	matchUrl: "",
	paymentSuccess: false,
	setPaymentSuccess: (_: boolean) => {},
	errors: [],
	redirectUrl: "",
	setRedirectUrl: (_: string) => {},
});
